<template>
<div class="flex-c">
    <div class="swipe-wrap flex-self-ctr">
        <van-image :src="bannerImg" width="10rem"></van-image>
    </div>
    <section>
        <van-tabs v-model="activeTab" sticky title-active-color="green" line-width="26" color="green" type="line" :border="tabBorder" @click="getNewsList">
            <!-- <van-tab title="产品" name="产品">
                <LeftAndRight />
            </van-tab> -->
            <van-tab title="新闻" name="新闻">
                <!-- 左文右图 -->
                <LeftAndRight />
            </van-tab>
        </van-tabs>
    </section>
    <img src="" alt="">
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import LeftAndRight from './../../components/LeftAndRight.vue'
export default {
    components: {
        LeftAndRight
    },
    data() {
        return {
            activeTab: '新闻',
            tabBorder: false,
            bannerImg: ''
        }
    },
    computed: {
        ...mapGetters([
            'newsListMsg'
        ])
    },
    created() {
        let currentType = this.$route.query.type;
        this.$store.dispatch('changeNewCategory', {
            category: 'news'
        });
        if (currentType === '心血管') {
            document.title = '心血管';
            this.bannerImg = require('@/assets/cardiovascular_intro.jpg');
            this.$store.dispatch('changeNewType', {
                type: 4
            });
        } else {
            document.title = '代谢';
            this.bannerImg = require('@/assets/metabolize_intro.jpg');
            this.$store.dispatch('changeNewType', {
                type: 5
            });
        }
    },
    methods: {
        getNewsList(e) {
            if (e === '产品') {
                this.$store.dispatch('changeNewCategory', {
                    category: 'product'
                });
                this.$store.dispatch('getNewsListApi');
            } else {
                this.$store.dispatch('changeNewCategory', {
                    category: 'news'
                });
                this.$store.dispatch('getNewsListApi');
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.swipe-wrap {
    height: auto;
    overflow: hidden;
}
</style>
